package com.milta.feature.subscription.domain.entity

data class SubscriptionPlanInfo(
    val plan: SubscriptionPlan,
    val storeProductId: String,
    val price: Double,
    // MIL-64 — tax-exclusive (HT) price, for display/invoicing purposes only. `price` above
    // remains the tax-inclusive (TTC) amount actually charged by the store and paid by the user.
    val priceExclTax: Double,
    val currency: String,
    val billingPeriod: String,
)
